import { Stack, Skeleton, Box } from "@mui/material";

type Props = {
  variant?: "dots" | "table" | "cards" | "page";
};

const LoadingState = ({ variant = "dots" }: Props) => {
  if (variant === "table") {
    return (
      <Stack gap={1}>
        <Skeleton variant="rounded" height={48} />
        {Array.from({ length: 5 }).map((_, i) => (
          <Skeleton key={i} variant="rounded" height={52} />
        ))}
      </Stack>
    );
  }

  if (variant === "cards") {
    return (
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            sm: "repeat(2, minmax(0, 1fr))",
            lg: "repeat(3, minmax(0, 1fr))",
          },
          gap: 2,
          width: "100%",
        }}
      >
        {Array.from({ length: 8 }).map((_, i) => (
          <Skeleton
            key={i}
            variant="rounded"
            height={148}
            sx={{ width: "100%", borderRadius: "14px" }}
          />
        ))}
      </Box>
    );
  }

  if (variant === "page") {
    return (
      <Stack gap={3}>
        <Skeleton variant="rounded" width={240} height={36} />
        <Stack direction="row" gap={2} flexWrap="wrap">
          {Array.from({ length: 3 }).map((_, i) => (
            <Skeleton key={i} variant="rounded" width={150} height={40} />
          ))}
        </Stack>
        <Skeleton variant="rounded" height={400} />
      </Stack>
    );
  }

  return (
    <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}>
      <span className="loader" />
    </Box>
  );
};

export default LoadingState;
